<template>
  <div :class="classnames">
    <popup-hitzone
      :close="close"
      :listenFor="openOn"
      @click="handleHitzoneClick"
      @mousein="handleHitzoneMouseIn"
      @mouseout="handleHitzoneMouseOut"
    >
      <popup-control>
        <slot name="control" />
      </popup-control>

      <popup-area :isVisible="isOpen">
        <popup-content>
          <slot name="content" />
        </popup-content>
      </popup-area>
    </popup-hitzone>
  </div>
</template>

<script>
  import PopupArea from './PopupArea'
  import PopupContent from './PopupContent'
  import PopupControl from './PopupControl'
  import PopupHitzone from './PopupHitzone'

  import { bem } from '@/mixins/bem.js'
  import { stringPropValidator } from '@/utils/stringPropValidator.js'

  const namespace = 'popup'

  const modifiers = {
    isOpen: 'is-open'
  }

  export default {
    name: 'Popup',
    components: {
      'popup-area': PopupArea,
      'popup-content': PopupContent,
      'popup-control': PopupControl,
      'popup-hitzone': PopupHitzone
    },
    mixins: [ bem ],
    props: {
      openOn: {
        default: 'click',
        type: String,
        validator: function (value) {
          return stringPropValidator(value, ['click', 'hover'])
        }
      }
    },
    data: function () {
      return {
        isOpen: false
      }
    },
    watch: {
      isOpen: function () {
        this.$emit('openchange', this.isOpen)
      }
    },
    created: function () {
      this.namespace = namespace
    },
    methods: {
      classnameModifiers: function () {
        const isOpen = this.isOpen && modifiers.isOpen

        return [ isOpen ]
      },
      close: function () {
        this.isOpen = false
      },
      handleHitzoneClick: function () {
        this.toggleOpenState()
      },
      handleHitzoneMouseIn: function () {
        this.open()
      },
      handleHitzoneMouseOut: function () {
        this.close()
      },
      open: function () {
        this.isOpen = true
      },
      toggleOpenState: function () {
        const isOpen = this.isOpen

        if (isOpen) {
          this.close()
        } else {
          this.open()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/Popup/Popup.vue